module.exports = __webpack_public_path__ + "img/kort3.5df9a0da.jpg";